export default function Footer() {
  return (
    <footer>
      <p>© 2026 onlinepk.me. All rights reserved.</p>
    </footer>
  );
}